module.exports = __webpack_public_path__ + "img/template.9906daf1.jpg";